export default __webpack_public_path__ + "static/media/checkLightTeal.06848961.svg";